import script from "./company-profile.vue?vue&type=script&setup=true&lang=js"
export * from "./company-profile.vue?vue&type=script&setup=true&lang=js"

import "./company-profile.vue?vue&type=style&index=0&id=65066045&lang=scss"

const __exports__ = script;

export default __exports__